(ns common.schema.entities.volume-data
  (:require [common.schema.schema-utils :as su]))

(defn- system-controlled-volume-data-field
  [[attribute field]]
  [attribute (assoc field :field/system-semantics su/system-controlled-optional-field-semantics)])

(def schema
  (mapv
   system-controlled-volume-data-field
   [[:volume-data/date {:field/data-type             :data.type/datetime
                        :field/default-visibility    {:editor           :editor.type/none
                                                      :grid             :editor.type/none
                                                      :filter           :filter.type/none
                                                      :field-visibility :in-use-disabled}
                        :field/default-authorization {:access/read  :role/user
                                                      :access/write :role/system}}]

    [:volume-data/deals-on-hold {:field/data-type             :data.type/ref-multi
                                 :field/default-visibility    {:editor           :editor.type/none
                                                               :grid             :editor.type/none
                                                               :filter           :filter.type/none
                                                               :field-visibility :in-use-disabled}
                                 :field/default-authorization {:access/read  :role/user
                                                               :access/write :role/system}}]
    [:volume-data/deals-passed {:field/data-type             :data.type/ref-multi
                                :field/default-visibility    {:editor           :editor.type/none
                                                              :grid             :editor.type/none
                                                              :filter           :filter.type/none
                                                              :field-visibility :in-use-disabled}
                                :field/default-authorization {:access/read  :role/user
                                                              :access/write :role/system}}]
    [:volume-data/deals-reactivated {:field/data-type             :data.type/ref-multi
                                     :field/default-visibility    {:editor           :editor.type/none
                                                                   :grid             :editor.type/none
                                                                   :filter           :filter.type/none
                                                                   :field-visibility :in-use-disabled}
                                     :field/default-authorization {:access/read  :role/user
                                                                   :access/write :role/system}}]
    [:volume-data/deals-seen {:field/data-type             :data.type/ref-multi
                              :field/default-visibility    {:editor           :editor.type/none
                                                            :grid             :editor.type/none
                                                            :filter           :filter.type/none
                                                            :field-visibility :in-use-disabled}
                              :field/default-authorization {:access/read  :role/user
                                                            :access/write :role/system}}]
    [:volume-data/deals-to-portfolio {:field/data-type             :data.type/ref-multi
                                      :field/default-visibility    {:editor           :editor.type/none
                                                                    :grid             :editor.type/none
                                                                    :filter           :filter.type/none
                                                                    :field-visibility :in-use-disabled}
                                      :field/default-authorization {:access/read  :role/user
                                                                    :access/write :role/system}}]]))
